import type { TenantConfig } from '@lensora/shared'
import { useQuery } from '@tanstack/react-query'


import { useMe } from './use-me'

import { api } from '@/lib/api'


export function useTenantConfig() {
  const { data: me } = useMe()
  const tenantSlug = me?.tenant?.slug

  return useQuery({
    queryKey: ['tenant-config', tenantSlug],
    queryFn: () =>
      api.get<TenantConfig>('/api/tenant-config', {
        headers: { 'X-Tenant-Slug': tenantSlug! },
      }),
    enabled: !!tenantSlug,
    staleTime: 1000 * 60 * 10,
  })
}
